/* CompuMe V4 Recently Viewed hardfix - 2026-08-31
 * Purpose: make Recently Viewed deterministic on product pages.
 * - No permanent skeleton cards.
 * - No hidden-parent Slick initialization.
 * - Safe grid fallback when Slick is unavailable or calculates broken slide widths.
 * - Keeps Shopify.Products API for Ella popup compatibility.
 */
(function () {
  'use strict';

  var COOKIE = 'shopify_recently_viewed';
  var MAX_MEMORY = 10;
  var DEFAULT_LIMIT = 10;

  function rootPath() {
    var root = window.routes && typeof window.routes.root === 'string' ? window.routes.root : '';
    if (!root || root === '/') return '';
    return root.replace(/\/$/, '');
  }

  function sanitizeHandle(value) {
    var handle = String(value || '').trim();
    return /^[a-z0-9][a-z0-9-]*$/i.test(handle) ? handle : '';
  }

  function uniqueHandles(values) {
    var seen = Object.create(null);
    var result = [];
    (values || []).forEach(function (value) {
      var handle = sanitizeHandle(value);
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      result.push(handle);
    });
    return result;
  }

  function currentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    return match ? sanitizeHandle(match[1]) : '';
  }

  function readRawCookie() {
    var prefix = COOKIE + '=';
    var parts = String(document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        try { return decodeURIComponent(part.slice(prefix.length)); }
        catch (e) { return part.slice(prefix.length); }
      }
    }
    return '';
  }

  function readHistory() {
    var values = [];
    var cookieValue = readRawCookie();
    if (cookieValue) values = values.concat(cookieValue.split(/\s+/));
    try {
      var localValue = localStorage.getItem(COOKIE);
      if (localValue) values = values.concat(localValue.split(/\s+/));
    } catch (e) {}
    return uniqueHandles(values).slice(0, MAX_MEMORY);
  }

  function writeHistory(handles, days) {
    handles = uniqueHandles(handles).slice(0, MAX_MEMORY);
    var value = handles.join(' ');
    try { localStorage.setItem(COOKIE, value); } catch (e) {}
    try {
      var expireDays = parseInt(days || 90, 10) || 90;
      var expires = new Date(Date.now() + expireDays * 86400000).toUTCString();
      document.cookie = COOKIE + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
    } catch (e) {}
    return handles;
  }

  function removeFromHistory(handle) {
    handle = sanitizeHandle(handle);
    if (!handle) return;
    writeHistory(readHistory().filter(function (item) { return item !== handle; }));
  }

  function recordRecentlyViewed(params) {
    params = params || {};
    var current = currentProductHandle();
    if (!current) return;
    var handles = readHistory().filter(function (handle) { return handle !== current; });
    handles.unshift(current);
    writeHistory(handles, params.expires || 90);
  }

  function installJQueryCookie(attempt) {
    attempt = attempt || 0;
    if (window.jQuery) {
      if (!window.jQuery.cookie) {
        window.jQuery.cookie = function (name, value, options) {
          if (typeof value !== 'undefined') {
            options = options || {};
            if (value === null) {
              value = '';
              options.expires = -1;
            }
            var expires = '';
            if (options.expires) {
              var date;
              if (typeof options.expires === 'number') {
                date = new Date();
                date.setTime(date.getTime() + options.expires * 86400000);
              } else {
                date = options.expires;
              }
              expires = '; expires=' + date.toUTCString();
            }
            var path = options.path ? '; path=' + options.path : '; path=/';
            var domain = options.domain ? '; domain=' + options.domain : '';
            var secure = options.secure ? '; secure' : '';
            document.cookie = name + '=' + encodeURIComponent(value) + expires + path + domain + secure;
            return;
          }
          if (name === COOKIE) return readRawCookie() || null;
          var prefix = name + '=';
          var parts = String(document.cookie || '').split(';');
          for (var i = 0; i < parts.length; i++) {
            var part = parts[i].trim();
            if (part.indexOf(prefix) === 0) {
              try { return decodeURIComponent(part.slice(prefix.length)); }
              catch (e) { return part.slice(prefix.length); }
            }
          }
          return null;
        };
      }
      return;
    }
    if (attempt < 100) setTimeout(function () { installJQueryCookie(attempt + 1); }, 50);
  }

  function fetchProductView(handle, view) {
    handle = sanitizeHandle(handle);
    if (!handle) return Promise.resolve({ stale: true, html: '' });
    var url = rootPath() + '/products/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view);
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (response.status === 404 || response.status === 410) return { stale: true, html: '' };
      if (!response.ok) return { stale: false, html: '' };
      return response.text().then(function (html) {
        html = String(html || '').trim();
        if (!html || html.indexOf('class="product') === -1 && html.indexOf("class='product") === -1 && html.indexOf('class="item') === -1) {
          return { stale: false, html: '' };
        }
        return { stale: false, html: html };
      });
    }).catch(function () {
      return { stale: false, html: '' };
    });
  }

  function runThemeCardHelpers() {
    try { if (typeof window.checkNeedToConvertCurrency === 'function') window.checkNeedToConvertCurrency(); } catch (e) {}
    try { if (typeof window.initColorSwatchGrid === 'function') window.initColorSwatchGrid(); } catch (e) {}
    try { if (window.compare && typeof window.compare.init === 'function') window.compare.init(); } catch (e) {}
    try { if (window.sharedFunctions && typeof window.sharedFunctions.productCountdownCard === 'function') window.sharedFunctions.productCountdownCard(); } catch (e) {}
    try { if (window.sharedFunctions && typeof window.sharedFunctions.swapHoverVideoProductCard === 'function') window.sharedFunctions.swapHoverVideoProductCard(); } catch (e) {}
    try { if (window.sharedFunctionsAnimation && typeof window.sharedFunctionsAnimation.onEnterButton === 'function') window.sharedFunctionsAnimation.onEnterButton(); } catch (e) {}
    try { if (window.sharedFunctionsAnimation && typeof window.sharedFunctionsAnimation.onLeaveButton === 'function') window.sharedFunctionsAnimation.onLeaveButton(); } catch (e) {}
  }

  function installSectionStyles() {
    if (document.getElementById('cmv4-rv-hardfix-style')) return;
    var style = document.createElement('style');
    style.id = 'cmv4-rv-hardfix-style';
    style.textContent = [
      '.halo-recently-viewed-block[data-cm-state="loading"]{visibility:hidden}',
      '.halo-recently-viewed-block[data-cm-state="empty"]{display:none!important}',
      '.halo-recently-viewed-block[data-cm-state="ready"]{visibility:visible}',
      '.halo-recently-viewed-block .cmv4-rv-grid-fallback{display:grid!important;grid-template-columns:repeat(5,minmax(0,1fr));gap:18px;margin-left:0!important;margin-right:0!important;white-space:normal!important}',
      '.halo-recently-viewed-block .cmv4-rv-grid-fallback>.product{width:auto!important;max-width:none!important;min-width:0!important;float:none!important;padding:0!important;margin:0!important;display:block!important}',
      '.halo-recently-viewed-block .cmv4-rv-grid-fallback .product-item,.halo-recently-viewed-block .cmv4-rv-grid-fallback .card{width:100%!important}',
      '@media(max-width:1199px){.halo-recently-viewed-block .cmv4-rv-grid-fallback{grid-template-columns:repeat(4,minmax(0,1fr))}}',
      '@media(max-width:767px){.halo-recently-viewed-block .cmv4-rv-grid-fallback{grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function boolData(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    return String(value).toLowerCase() === 'true' || String(value) === '1';
  }

  function setBlockReady(block) {
    block.dataset.cmState = 'ready';
    block.style.removeProperty('display');
    block.style.removeProperty('visibility');
    runThemeCardHelpers();
  }

  function useGridFallback(block, row) {
    installSectionStyles();
    try {
      var jq = window.jQuery;
      if (jq && jq.fn && typeof jq.fn.slick === 'function') {
        var $row = jq(row);
        if ($row.hasClass('slick-initialized')) $row.slick('unslick');
      }
    } catch (e) {}
    row.classList.remove('slick-initialized');
    row.classList.add('cmv4-rv-grid-fallback');
    setBlockReady(block);
  }

  function rowLooksCollapsed(row) {
    if (!row || !row.children || !row.children.length) return false;
    var rowBox = row.getBoundingClientRect();
    var first = row.querySelector('.slick-slide:not(.slick-cloned), .product');
    if (!first) return false;
    var itemBox = first.getBoundingClientRect();
    if (rowBox.width >= 600 && itemBox.width > 0 && itemBox.width < 90) return true;
    if (rowBox.width >= 600 && itemBox.height > 600) return true;
    return false;
  }

  function initSliderOrFallback(block, row, attempt) {
    attempt = attempt || 0;
    installSectionStyles();

    var layout = String(block.dataset.layout || '').toLowerCase();
    if (layout !== 'slider') {
      useGridFallback(block, row);
      return;
    }

    var jq = window.jQuery;
    if (jq && jq.fn && typeof jq.fn.slick === 'function') {
      try {
        block.style.removeProperty('display');
        block.style.visibility = 'hidden';

        var $row = jq(row);
        if ($row.hasClass('slick-initialized')) {
          try { $row.slick('unslick'); } catch (e) {}
        }

        var desktop = Math.max(1, parseInt(row.getAttribute('data-item-to-show') || '5', 10) || 5);
        var arrowsDesktop = boolData(row.getAttribute('data-item-arrows'), true);
        var arrowsMobile = boolData(row.getAttribute('data-item-arrows-mb'), false);
        var dotsDesktop = boolData(row.getAttribute('data-item-dots'), false);
        var dotsMobile = boolData(row.getAttribute('data-item-dots-mb'), false);

        $row.slick({
          mobileFirst: true,
          adaptiveHeight: true,
          vertical: false,
          infinite: row.children.length > desktop,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: arrowsMobile,
          dots: dotsMobile,
          nextArrow: window.arrows && window.arrows.icon_next ? window.arrows.icon_next : '<button type="button" class="slick-next" aria-label="Next">›</button>',
          prevArrow: window.arrows && window.arrows.icon_prev ? window.arrows.icon_prev : '<button type="button" class="slick-prev" aria-label="Previous">‹</button>',
          rtl: !!window.rtl_slick,
          responsive: [
            { breakpoint: 320, settings: { slidesToShow: Math.min(2, desktop), slidesToScroll: Math.min(2, desktop), arrows: arrowsMobile, dots: dotsMobile } },
            { breakpoint: 767, settings: { slidesToShow: Math.min(3, desktop), slidesToScroll: Math.min(3, desktop), arrows: arrowsMobile, dots: dotsMobile } },
            { breakpoint: 991, settings: { slidesToShow: Math.min(4, desktop), slidesToScroll: Math.min(4, desktop), arrows: arrowsMobile, dots: dotsMobile } },
            { breakpoint: 1024, settings: { slidesToShow: desktop === 5 ? 4 : desktop, slidesToScroll: desktop === 5 ? 4 : desktop, arrows: arrowsDesktop, dots: dotsDesktop } },
            { breakpoint: 1599, settings: { slidesToShow: desktop, slidesToScroll: desktop, arrows: arrowsDesktop, dots: dotsDesktop } }
          ]
        });

        setBlockReady(block);
        setTimeout(function () {
          try { $row.slick('setPosition'); } catch (e) {}
        }, 50);
        setTimeout(function () {
          if (rowLooksCollapsed(row)) useGridFallback(block, row);
        }, 300);
        return;
      } catch (e) {
        useGridFallback(block, row);
        return;
      }
    }

    if (attempt < 25) {
      setTimeout(function () { initSliderOrFallback(block, row, attempt + 1); }, 100);
    } else {
      useGridFallback(block, row);
    }
  }

  function loadSectionBlock(block) {
    if (!block || block.dataset.cmRvStarted === 'true') return;
    block.dataset.cmRvStarted = 'true';
    block.dataset.cmState = 'loading';
    block.classList.add('ajax-loaded');
    installSectionStyles();

    var row = block.querySelector('.recentlyViewed-row');
    if (!row) {
      block.dataset.cmState = 'empty';
      return;
    }

    var limit = Math.max(1, Math.min(20, parseInt(block.dataset.limit || DEFAULT_LIMIT, 10) || DEFAULT_LIMIT));
    var current = currentProductHandle();
    var historyBeforeRecord = readHistory();
    var candidates = historyBeforeRecord.filter(function (handle) { return handle !== current; }).slice(0, limit);

    if (current) recordRecentlyViewed();

    row.innerHTML = '';

    if (!candidates.length) {
      block.dataset.cmState = 'empty';
      return;
    }

    var htmlParts = [];
    var stale = Object.create(null);
    var chain = Promise.resolve();

    candidates.forEach(function (handle) {
      chain = chain.then(function () {
        if (htmlParts.length >= limit) return;
        return fetchProductView(handle, 'ajax_section_recently_viewed').then(function (result) {
          if (result.stale) stale[handle] = true;
          if (result.html) htmlParts.push(result.html);
        });
      });
    });

    chain.then(function () {
      var staleKeys = Object.keys(stale);
      if (staleKeys.length) {
        writeHistory(readHistory().filter(function (handle) { return !stale[handle]; }));
      }
      if (!htmlParts.length) {
        block.dataset.cmState = 'empty';
        return;
      }
      row.innerHTML = htmlParts.join('');
      initSliderOrFallback(block, row, 0);
    }).catch(function () {
      block.dataset.cmState = 'empty';
    });
  }

  function loadAllSectionBlocks() {
    var blocks = document.querySelectorAll('[data-recently-viewed-block]');
    Array.prototype.forEach.call(blocks, loadSectionBlock);
  }

  function showRecentlyViewed(params) {
    params = params || {};
    var wrapper = document.getElementById(params.wrapperId || 'recently-viewed-products');
    var limit = Math.max(1, Math.min(20, parseInt(params.howManyToShow || DEFAULT_LIMIT, 10) || DEFAULT_LIMIT));
    var isPopup = params.templateId === 'recently-viewed-product-popup';
    var view = isPopup ? 'ajax_recently_viewed' : 'ajax_section_recently_viewed';
    var handles = readHistory().slice(0, limit);

    if (!wrapper || !handles.length) {
      if (typeof params.onComplete === 'function') params.onComplete();
      return;
    }

    if (isPopup) {
      var noProducts = wrapper.querySelector('.no-products');
      if (noProducts) noProducts.remove();
    }

    var htmlParts = [];
    var chain = Promise.resolve();
    handles.forEach(function (handle) {
      chain = chain.then(function () {
        if (htmlParts.length >= limit) return;
        return fetchProductView(handle, view).then(function (result) {
          if (result.stale) removeFromHistory(handle);
          if (result.html) htmlParts.push(result.html);
        });
      });
    });

    chain.then(function () {
      if (htmlParts.length) wrapper.insertAdjacentHTML('beforeend', htmlParts.join(''));
      if (!isPopup) {
        var block = wrapper.closest('[data-recently-viewed-block]');
        if (block) initSliderOrFallback(block, wrapper, 0);
      }
      if (typeof params.onComplete === 'function') params.onComplete();
    }).catch(function () {
      if (typeof params.onComplete === 'function') params.onComplete();
    });
  }

  function resizeImage(src, size) {
    if (!src || size == null) return src;
    if (size === 'master') return String(src).replace(/http(s)?:/, '');
    var match = String(src).match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
    if (!match) return src;
    var prefix = String(src).split(match[0]);
    return (prefix[0] + '_' + size + match[0]).replace(/http(s)?:/, '');
  }

  installJQueryCookie();

  window.Shopify = window.Shopify || {};
  window.Shopify.Products = {
    resizeImage: resizeImage,
    showRecentlyViewed: showRecentlyViewed,
    getConfig: function () { return { howManyToStoreInMemory: MAX_MEMORY }; },
    clearList: function () { writeHistory([]); },
    recordRecentlyViewed: recordRecentlyViewed
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAllSectionBlocks);
  } else {
    loadAllSectionBlocks();
  }
})();